import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyMask]'
})
export class CurrencyMaskDirective {

  constructor(
    private model: NgControl
  ) { }

  @Input('appCurrencyMask') isStart: boolean;

  @HostListener('ngModelChange') ngModelChange() {
    this.modelValue();
  }

  @HostListener('keydown.backspace') onKeyDownBackspace() {
    this.modelValue(true);
  }

  private modelValue(backspace?: boolean) {
    if (this.model) {
      var model: any = this.model;
      if(model.viewModel) {
        if (typeof model.viewModel === 'number') {
          model.viewModel = model.viewModel.toString();
        }
        this.inputChange(model.viewModel, backspace);
      }
    }
  }

  private inputChange(model: any, backspace?: any) {
    if (model) {
      var start = this.isStart;
      var newVal = model;//.replace(/\D/g, '');

      // if (backspace) {
      //   if(newVal.length){
      //     newVal = newVal.substring(0, newVal.length - 1);
      //   }
      // }

      var formatted:string = '',
        x:number, lenX:number;

      if (!newVal) {
        newVal = 0;
      } else {
        newVal = newVal.toString();
        if (start) {
          var point = newVal.indexOf(".");
          if (point === -1) {
            newVal = newVal + '00';
          } else {
            var afterPoint = newVal.slice(point + 1, newVal.length);
            if (afterPoint.length < 2) {
              newVal = newVal + '0';
            }
          }

          newVal = newVal.replace(".", "");
        } else {
          newVal = newVal.replace(/\D/g, '').replace(/\./g, '').replace(/,/g, '').replace(/^0+/, '');
        }

        if (newVal.length == 2) newVal = '0' + newVal;
        if (newVal.length == 1) newVal = '00' + newVal;

        for (x = 0, lenX = newVal.length; x < lenX; x++) {
          var sep = '';
          if (x == 2) sep = ',';
          if (x > 3 && (x + 1) % 3 == 0) sep = '.';
          formatted = newVal.substring(newVal.length - 1 - x, newVal.length - x) + sep + formatted;
        }

        newVal = formatted;
        if (!newVal) {
          newVal = 0;
        }
      }

      this.model.valueAccessor.writeValue(newVal);
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/currency-mask.directive.ts
 **/